module.exports = __webpack_public_path__ + "img/sortImg1-1-7.15563d0e.png";